import { CadModelCategoriesClient, CadModelCategory } from "@api/apiClient";
import axios from "@api/axiosInstance";
import { useQuery } from "@tanstack/react-query";

const cadModelCategoriesClient = new CadModelCategoriesClient(undefined, axios);

export const useCadModelCategories = (options?: any) => {
  return useQuery<CadModelCategory[]>({
    ...options,
    queryKey: ["cadModelCategories"],
    queryFn: async () => cadModelCategoriesClient.getCadModelCategories(),
    staleTime: 30 * 60 * 1000, // 30 minutes
    cacheTime: 60 * 60 * 1000, // 60 minutes
  });
};

